import { requests } from "../../../api/agent"

export default {
	create               : (params) => requests.post('/ReInterdigitCoefficient/create', params),
	update               : (params) => requests.post('/ReInterdigitCoefficient/update', params),
	delete               : (params) => requests.getWithParams('/ReInterdigitCoefficient/delete', params),
	restore              : (params) => requests.getWithParams('/ReInterdigitCoefficient/restore', params),
	getPaged             : (params) => requests.getWithParams('/ReInterdigitCoefficient/getPaged', params),
	getPagedAll          : (params) => requests.getWithParams('/ReInterdigitCoefficient/getPagedAll', params),
	getPagedAudit        : (params) => requests.getWithParams('/ReInterdigitCoefficient/getPagedAudit', params),
}
